<p-toast></p-toast>
<div [class]="'mt-3 surface-50 border-round-md ' + containerClass">
  <div
    class="flex flex-column text-base font-medium"
    *ngIf="(disabled && files.length > 0) || !disabled"
  >
    <div
      class="flex align-items-center justify-content-center h-10rem border-round m-3"
      *ngIf="!disabled"
    >
      <ngx-file-drop
        class="w-full"
        [accept]="acceptType.join(',')"
        dropZoneLabel="Drop files here"
        (onFileDrop)="onFileDrop($event)"
        [multiple]="multipleSelect"
        contentClassName=""
        dropZoneClassName=""
      >
        <ng-template
          ngx-file-drop-content-tmp
          let-openFileSelector="openFileSelector"
        >
          <div class="flex flex-column">
            <div class="flex align-items-center justify-content-center mt-3">
              <i class="pi pi-cloud-upload"></i>
            </div>
            <div class="flex align-items-center justify-content-center mt-3">
              <span>{{ 'CLICK_TO_UPLOAD_OR_DND' | translate }}</span>
            </div>
            <div class="flex align-items-center justify-content-center mt-3">
              <p-button
                *ngIf="multipleSelect"
                class="choose-files-btn"
                type="button"
                (click)="openFileSelector()"
                >{{ 'CHOOSE_FILES' | translate }}</p-button
              >
              <p-button
                *ngIf="!multipleSelect"
                class="choose-files-btn"
                type="button"
                (click)="openFileSelector()"
                >{{ 'CHOOSE_FILE' | translate }}</p-button
              >
            </div>
            <div class="flex align-items-center justify-content-center mt-3">
              <span
                >File format: {{ acceptType.join(', ') }} (Max.
                {{ maxFileSize }}MB)</span
              >
            </div>
          </div>
        </ng-template>
      </ngx-file-drop>
    </div>
    <div
      class="flex align-items-center justify-content-center xl:h-full border-round m-3"
    >
      <div class="card w-11">
        <div
          class="flex flex-column card-container"
          *ngFor="let file of files; let index = index"
        >
          <div
            class="flex align-items-center p-2 bg-teal-300 mt-1 border-round-md text-white"
          >
            <div class="flex card-container align-items-center w-12">
              <div class="flex-none flex">
                <span><i [class]="file.icon || 'pi pi-check-circle'"></i></span>
              </div>

              <div class="flex-grow-1 flex align-items-center w-10">
                <a
                  target="_blank"
                  [href]="file.viewAttachmentUrl"
                  [download]="file.name"
                  class="max-w-17rem file-name no-underline text-white inline-block mx-3 text-sm font-normal white-space-nowrap overflow-hidden text-overflow-ellipsis"
                  [pTooltip]="file.name"
                  tooltipPosition="top"
                  appendTo="body"
                  >{{ file.name }}</a
                >
              </div>

              <div class="flex-none flex">
                <a
                  *ngIf="!disabledFile"
                  class="file-remove-btn cursor-pointer"
                  (click)="removeFile(index)"
                  ><i class="pi pi-times text-xs"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
